<template>
  <div class="wrld-overview mb-4">
    <v-row align="center" justify="space-between">
      <h2>{{title}}</h2>
      <div>
        <slot name="headerBtns"></slot>
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'wrld-out-of-box',
  props: {
    title: String
  }
}
</script>

<style scoped>
  h2 {
    padding-left: 25px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.02em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
